import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
function Navbar() {
  const cartitems = useSelector((state) => state.cart);
  const subtotalvalue = cartitems.reduce((acc, item) => item.Quantity + acc, 0);
  return (
    <nav className="bg-[#171C2A] py-4">
      <div className="navBar">
        <Link to="/">
          <img src="./images/logo.png" alt="LWS" className="max-w-[140px]" />
        </Link>
        <div className="flex gap-4">
          <Link to="/home" className="navHome" id="lws-home">
            Home
          </Link>
          <Link to="/cart" className="navCart" id="lws-cart">
            <i className="text-xl fa-sharp fa-solid fa-bag-shopping" />
            <span id="lws-totalCart">{subtotalvalue}</span>
          </Link>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
